import { pxToMMConversionCls, tokens } from './shared.size-tokens.style.js';
import { jsx } from 'react/jsx-runtime';

function Slot(props) {
  if (!props.slot) {
    return null;
  }
  const {
    content,
    designSizeInPx
  } = props.slot(props.context);
  return /*#__PURE__*/jsx("div", {
    className: pxToMMConversionCls,
    style: tokens.__override({
      designHeightInPx: designSizeInPx.height,
      designWidthInPx: designSizeInPx.width
    }),
    children: content
  });
}

export { Slot };
//# sourceMappingURL=comp.slot.js.map
